// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ReceptionAction } from '../duck';
import Reception from '../components/Reception';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingReceptionOrders: state.courier.inCourierFlowOrdersState.isFetchingReceptionOrders,
    receptionOrders: state.courier.inCourierFlowOrdersState.receptionOrders,
    fetchReceptionOrdersError: state.courier.inCourierFlowOrdersState.fetchReceptionOrdersError,
    isReceivingOrderItemMap: state.courier.inCourierFlowOrdersState.isReceivingOrderItemMap,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...ReceptionAction }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Reception);





// WEBPACK FOOTER //
// ./src/modules/courier/recepetion/container/ReceptionContainer.js